import { useCopy } from '../content'
import { ContactSection } from '../components/contact/ContactSection'

/**
 * Contatti: the page title as the one `<h1>`, then the same forest band the
 * home page closes with (it keeps its own `<h2>`; the shared form's own
 * heading stays hidden by `hideInfoHeading`).
 */
export default function ContactPage() {
  const copy = useCopy()
  return (
    <main id="main">
      <section className="vc2-container pt-32 pb-8">
        <h1 tabIndex={-1} className="vc2-display text-4xl md:text-6xl">
          {copy.contact.pageTitle}
        </h1>
      </section>
      <ContactSection />
    </main>
  )
}
